<script setup lang="ts">
import NavBar from "~/components/Navbar/NavBar.vue";
import HomeActionsMobile from "~/components/Pages/home/HomeActionsMobile.vue";
import NavBarMobile from "~/components/Navbar/NavBarMobile.vue";
import { useNavbar } from "~/composables/navbar/useNavbar";
import { useAuthStore } from "~/store/auth/auth.store";
import { useEmbedStore } from "~/store/embed/embed.store";

const open = ref(false);
const authStore = useAuthStore();
const embedStore = useEmbedStore();
const { isCollapsed: isNavbarCollapsed } = useNavbar();

const { $Localize } = useNuxtApp();

const typedLocalize: any = $Localize;

onMounted(() => {
  // No fetchProfile() here: this layout only ever mounts behind `auth.global.ts`, which guarantees
  // isLoggedIn() — and that getter already requires `user`. The profile was loaded by `login()`
  // (funnel) or by `auth-plugin.ts` (reload) before any layout mounted, so re-reading it was a
  // third /users/profile round trip on every login and every layout change.
  if (authStore.isLoggedIn()) {
    typedLocalize.setLanguage(authStore.user?.language);
  }
});
</script>

<template>
  <div :class="['layout_container navbar_layout', { navbar_collapsed: isNavbarCollapsed }]">
    <template v-if="!embedStore.isEmbed">
      <NavBar></NavBar>
      <NavBarMobile></NavBarMobile>
    </template>

    <div id="right_container" :class="['right_container', { embed: embedStore.isEmbed }]">
      <HeaderHome v-if="!embedStore.isEmbed"></HeaderHome>
      <div :class="['slot', { embed: embedStore.isEmbed }]">
        <slot />
      </div>
    </div>
  </div>
  <template v-if="!embedStore.isEmbed">
    <div v-if="open" class="overlay" @click="(event: MouseEvent) => (open = false)"></div>

    <div class="home_menu md:hidden">
      <HomeActionsMobile :open="open" @update:open="(val) => (open = val)"> </HomeActionsMobile>
    </div>
  </template>
  <FeedbackContainer v-if="!embedStore.isEmbed"></FeedbackContainer>
</template>

<style scoped>
.layout_container {
  @apply flex flex-row;
  min-height: 100%;
}

.right_container {
  margin-left: var(--navbar_width);
  overflow-x: hidden;
  width: 100%;
  background: var(--white-main);
}

.right_container.embed {
  margin-left: 0;
}

.slot {
  min-width: calc(100vw - var(--navbar_width));
  height: calc(100vh - var(--header_home_height));
}

.slot.embed {
  min-width: unset;
  height: 100vh;
}

@media (max-width: 768px) {
  .slot {
    padding-right: 0px;
    padding-left: 0px;
    height: calc(100vh - 72px);
  }
}

@media (max-width: 768px) {
  .right_container {
    margin-left: 0;
  }
}

.home_menu {
  @apply sticky bottom-16 py-[16px] w-full bg-lightest-grey-color md:hidden rounded-t-lg;
  z-index: 101;
}
</style>
